import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/about/hero"
import Image from "../components/image"
// import Team from "components/about/team"

const AboutPage = () => {
  return (
    <Layout active="about" buttonText="Deploy a cluster">
      <SEO title="About Us" />
      <Hero />
      <section>
        <div className="my-32 w-11/12 md:w-9/12 xl:w-6/12 mx-auto fadeInUp delay-500ms">
          <h3
            className=" text-grey-100 font-semibold"
            style={{
              lineHeight: "60px",
              fontSize: "43px",
            }}
          >
            Exciting times, exciting moments and with exciting people.
          </h3>
          <p
            className="text-grey-200 text-lg mt-5"
            style={{ fontSize: "16.7px", lineHeight: "30px" }}
          >
            All we had was the ambition to simplify the way banking has ever
            been operated. We studying the market to understand the pain points
            and we came to the conclusion that bringing banking technology into
            the digital-first world and to make it accessible for any market
            opportunity will be a great news for techs. <br />
            <br />
            We dreamt big but wisely, WoodCore is currently in the business of
            servicing microfinance institutions and fintech startups. Within 6
            months our engine was adopted by 4 microfinance organisations in
            Nigeria.
          </p>
        </div>
      </section>

      <section>
        <div className="border-b border-grey-300 pb-32">
          <div className="mx-auto flex flex-col-reverse lg:flex-row items-center">
            <div className="lg:w-5/12 md:pr-16 mt-6 lg:mt-0">
              <div className="w-11/12 mx-auto md:pl-16">
                <h4 className="text-4xl text-grey-100 font-semibold">
                  WoodCore
                </h4>
                <p
                  className="text-grey-200 mt-2 w-11/12 pr-2"
                  style={{ lineHeight: "30px", fontSize: "17px" }}
                >
                  The financial industry is our home ground, which is why
                  WoodCore takes the initiative to improve it for the better.
                </p>
                <p
                  className="text-grey-200 mt-1"
                  style={{ lineHeight: "30px", fontSize: "17px" }}
                >
                  Nothing ensures our customers’ success more than a happy team,
                  therefore, WoodCore is built on a culture of trust and a true
                  sense of ownership by everyone.
                </p>
              </div>
            </div>
            <div className="lg:w-7/12 w-full">
              <Image source="woodCore" />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="my-24 pb-16">
          <h3
            className="text-grey-100 text-center font-semibold"
            style={{ fontSize: "43px" }}
          >
            Our Partners &amp; Clients
          </h3>
          <div className="w-11/12 lg:w-9/12 xl:w-7/12 mx-auto">
            <div className="flex items-center justify-between flex-wrap">
              <div className="mt-10  md:mt-12 mx-auto flex justify-center ">
                <object data={require("images/kredi.svg")} type="image/svg+xml">
                  Kredi logo
                </object>
              </div>
              <div className="mt-10  md:mt-12 mx-auto flex justify-center">
                <object
                  data={require("images/open-banking.svg")}
                  type="image/svg+xml"
                >
                  Open Banking logo
                </object>
              </div>
              <div className="mt-10 md:mt-12 mx-auto flex justify-center">
                <object
                  data={require("images/lendsqr.svg")}
                  type="image/svg+xml"
                >
                  Lendsqr logo
                </object>
              </div>
            </div>
            <div className="flex items-center mx-auto flex-wrap">
              <div className="mt-10 md:mt-12 mx-auto flex justify-center">
                <object
                  data={require("images/one-pipe.svg")}
                  type="image/svg+xml"
                >
                  One Pipe logo
                </object>
              </div>
              <div className="mt-10 md:mt-12 mx-auto flex justify-center">
                <object
                  data={require("images/assurdly.svg")}
                  type="image/svg+xml"
                >
                  Assurdly logo
                </object>
              </div>
              <div className="mt-10  md:mt-12 mx-auto flex justify-center">
                <object data={require("images/woven.svg")} type="image/svg+xml">
                  woven logo
                </object>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Team /> */}
    </Layout>
  )
}

export default AboutPage
